module.exports = __webpack_public_path__ + "img/camera.3852c780.png";